export default {
  API_ENDPOINT: 'https://whispering-waters-97945.herokuapp.com/api',
  TOKEN_KEY: process.env.REACT_APP_API_KEY,
}
